





















































import { Component, Vue, Prop } from "vue-property-decorator";
import TextStart from './textStart.vue'
import TextEnd from './textEnd.vue'
import TextPackUp from './textPackUp.vue'
import {PopSettingsVO, TFormSaveDetailRequest} from "@/model/FormWheel";
import { getFontFaceList } from "@/utils/getFontFaceList";
import { getVueAppUploadApi } from "@/services/util";


@Component({
  components: {
    'text-start': TextStart,
    'text-end': TextEnd,
    'text-pack-up': TextPackUp,
  },
})
export default class wheelOfFortuneText extends Vue {
  @Prop(String)
  activePageSetting!:string;

  @Prop(Number)
  triggerEventType!:any

  @Prop(Object)
  formData!:TFormSaveDetailRequest<PopSettingsVO>;

  @Prop(Array)
  countryList!:any

  @Prop({ type: String, default: 'success' })
  subscribeStatus!: string

  predefineColors = [
    '#ff4500',
    '#ff8c00',
    '#ffd700',
    '#90ee90',
    '#00ced1',
    '#1e90ff',
    '#c71585',
    '#f1b859',
    '#f4994b',
    '#d7394d',
    '#dd5b46',
    '#f7d69e',
    '#ffffff'
  ]

  public fontFaceList = getFontFaceList([
    {
      name: 'Arial',
      value: 'Arial, sans-serif',
      original: true
    },
    {
      name: 'Courier New',
      value: 'Courier New, monospace',
      original: true
    },
    {
      name: 'Georgia',
      value: 'Georgia, serif',
      original: true
    },
    {
      name: 'Times New Roman',
      value: 'Times New Roman, serif',
      original: true
    },
    {
      name: 'Trebuchet MS',
      value: 'Trebuchet MS, sans-serif',
      original: true
    },
    {
      name: 'Verdana',
      value: 'Verdana, sans-serif',
      original: true
    }
  ]);

  // 上传图片地址
  public uploadUrl = getVueAppUploadApi() + "/upload/formImage";

  async created(): Promise<void> {
  }





  //start
  changeTextStart(e:any){
    this.$emit('change',e)
  }
  changeTextEnd(e:any){
    this.$emit('change',e)
  }
  changeTextPackUp(e:any){
    this.$emit('change',e)
  }


  /**
   * 下一步
   */
  nextStep() {
    // this.SettingValid()
    if(this.triggerEventType == 0 || this.triggerEventType == 2 || this.triggerEventType == 8){
      if(!this.formData.settings.start.length){
        this.$message.warning('您未设置用户邮箱或手机号为必填，将导致未填写邮箱或手机号的用户信息无法保存，请添加手机号或邮箱后再次保存')
        return;
      }
    }
    this.$emit('nextStep')
  }

  /**
   * 上一步
   */
  backStep() {
    this.$emit('backStep')
  }

  /**
   * 取消
   */
  cancel() {
    this.$emit('cancel')
  }

}
